/**
 * Подвал доверия для ПУБЛИЧНЫХ экранов tenant-app (страница входа + анон-витрина).
 *
 * Зачем: рядом со сбором персональных данных (форма входа, заявка на бронь)
 * по 152-ФЗ нужна видимая ссылка на политику конфиденциальности; реквизиты ИП
 * + контакт снимают анти-флаг «deceptive» при ревью Apple/сторов.
 *
 * Generic UI без знания домена → живёт в shared/ui. Встраивается ТОЛЬКО в
 * публичные экраны (login, AnonymousMode), не в аутентифицированные дашборды.
 * Стиль — в гамме D5b (тёплый беж Lovart), компактно, внизу экрана.
 */
const PRIVACY_URL = 'https://lovarthotels.ru/legal/privacy';
const OFFER_URL = 'https://lovarthotels.ru/legal/offer';
const CONTACT_EMAIL = 'hello@lovarthotels.ru';

export function PublicTrustFooter(): JSX.Element {
  return (
    <footer className="hsc-trust" data-testid="public-trust-footer">
      <nav className="hsc-trust__links" aria-label="Правовая информация">
        <a
          className="hsc-trust__link"
          href={PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="trust-privacy-link"
        >
          Политика конфиденциальности
        </a>
        <span aria-hidden="true" className="hsc-trust__sep">
          ·
        </span>
        <a
          className="hsc-trust__link"
          href={OFFER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="trust-offer-link"
        >
          Оферта
        </a>
        <span aria-hidden="true" className="hsc-trust__sep">
          ·
        </span>
        <a
          className="hsc-trust__link"
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="trust-email-link"
        >
          {CONTACT_EMAIL}
        </a>
      </nav>
    </footer>
  );
}
